import { cn } from '@/lib/utils'

type DividerProps = {
  text?: string
  type?: 'horizontal' | 'vertical'
  textAlign?: 'left' | 'center' | 'right'
  className?: string
}

export const Divider = ({
  text,
  type = 'horizontal',
  textAlign = 'left',
  className,
}: DividerProps) => {
  const isHorizontal = type === 'horizontal'
  const orientation = isHorizontal
    ? 'my-4 h-[1px] w-full'
    : 'mx-4 w-[1px] h-full'

  // Only support text alignment for horizontal divider
  const renderText = () => {
    if (!text) return null

    if (!isHorizontal) {
      // For vertical, just show text at top
      return (
        <span className='absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 bg-white px-2 text-xs text-neutral-900'>
          {text}
        </span>
      )
    }

    let textPositionClass = ''
    if (textAlign === 'center') {
      textPositionClass = 'left-1/2 -translate-x-1/2'
    } else if (textAlign === 'right') {
      textPositionClass = 'right-12 left-auto'
    } else {
      // left
      textPositionClass = 'left-12'
    }

    return (
      <span
        className={cn(
          'absolute top-1/2 -translate-y-1/2 bg-white px-2 text-xs text-neutral-900',
          textPositionClass
        )}
      >
        {text}
      </span>
    )
  }

  return (
    <div
      className={cn('relative', orientation, 'bg-neutral-900/20', className)}
    >
      {renderText()}
    </div>
  )
}
